import dayjs from 'dayjs';

import appConfig from '../appConfig';

export const formatDate = (dateTime: dayjs.Dayjs) => {
	if (appConfig.regions.language === 'enUS') {
		return dateTime.format('ddd, MMM D, YYYY');
	}
	return dateTime.format('ddd D MMM YYYY');
};

export const formatTime = (dateTime: dayjs.Dayjs) => {
	if (appConfig.regions.language === 'enUS') {
		return dateTime.format('hh:mm:ss A');
	}
	return dateTime.format('HH:mm:ss Z');
};

export const formatDateGreenID = (dateTime: dayjs.Dayjs) => {
	if (appConfig.regions.language === 'enUS') {
		return dateTime.format('MM/DD/YYYY');
	}
	return dateTime.format('DD/MM/YYYY');
};

export const formatDepositPromotion = (dateTime: dayjs.Dayjs) => {
	if (appConfig.regions.language === 'enUS') {
		return dateTime.format('MMM DD [at] hh:mm A');
	}
	return dateTime.format('MMM DD [at] HH:mm a');
};
